import {
    PAGINATION_LIMIT,
    QUOTE_LIST_SORT_KEY,
} from '@Builder/QuotesHomePage/logic'

import { QUOTES_PATH } from '~/redux-modules/preferences'
import getColor from '~/lib/getColor'

export const PLACEMENT = 'admin_user_quotes'
export const BORDER = `1px solid ${getColor('blackAlpha15')}`
export const DEFAULT_OFFSET = 0
export const DECIMAL_BASE = 10

export const DEFAULT_QUOTES_LIST_QUERY_VARIABLES = {
    limit: PAGINATION_LIMIT,
    sort: QUOTE_LIST_SORT_KEY,
    offset: DEFAULT_OFFSET,
}

export const REDIRECT_URL = QUOTES_PATH
